<template lang="pug">
    header
        .header
            .main-width
                a(href="https://raid-gaming.net").logo
                    img(src="@/assets/logo.png")
            nav-bar
</template>

<script>
import NavBar from '@/components/core/NavBar.vue';

export default {
  name: 'AppHeader',
  components: {
    NavBar,
  },
};
</script>

<style lang="scss" scoped>
@import '@/style/definitions';

header {
  margin-bottom: 32px;

  @media screen and (max-width: 979px) {
      margin-top: 55px;
  }

  .header {
    display: block;
    background: $color-header-bg;

    border-top: 4px solid $color-accent;
    position: relative;
    background-image: url('./../..//assets/heading.png');
    background-position: center center;

    .main-width {
      height: 120px;
      .logo img {
        display: block;
        max-height: 50%;
        max-width: 100%;
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);

        @media screen and (max-width: 979px) {
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}
</style>
